module.exports = __webpack_public_path__ + "img/swipe.f8fa3b5a.gif";